export enum UserDataTypes {
    FILTERS = 0,
}
